export default __webpack_public_path__ + "static/media/planet3.3871b7b0.png";